import React, { useContext, useEffect, useState } from 'react';
import {
  ClientDataSearchColumn, ClientDataSearchError, ClientDataButtoCalculate, ClientDataAddButton, ClientDataButtoCalculateButton,
  ClientDataTotal, ClientDataTotalPrice, ClientDataTotalTitle, ClientDataMontoTotal, ClientDataTotalData, ClientDataTotalDataMin,
  ClientDataTotalDataMinBlack, InfoCircleImage, Tooltip, TooltipContent, TooltipTitle, ClientDataHead, ClientDataHeadLabel
} from './styles';
import { useForm, Controller } from 'react-hook-form';
import { SessionContext, AgileSimulatorContext } from '../../../store';
import { Form, FormFooterRigth, FormRow } from '../../../components/FormTemplate/styles';
import Select from '../../../components/Select';
import InputIntl from '../../../components/InputIntl';
import { currencyMoney } from '../../../config/currency';
import { SecondaryLargeButton } from '../../../components/Buttons/styles';
import { StepFourDisplayValuesRow, StepFourDisplayValuesRowValue } from '../../Simulator/Result/styles';
import { StepFourColumn, StepFourDisplayValues, StepFourDisplayResultLabel } from './styles';
import { formatPrice } from '../../../helpers/price';
import { getAgileLineasDeCredito, getAgileSimulatorCreditBound, getAgileSimulatorTasas, postAgileSimulatorResult } from '../../../services/agileSimulator';
import infoCircle from '../../../assets/images/info-circle.svg';
import InputDefault from '../../../components/InputDefault';
import Loader from '../../../components/Loader';
import ModalInfo from '../../../components/ModalInfo';
import { BsExclamation } from 'react-icons/bs';
import colors from '../../../assets/styles/colors';

const AgileSimulatorForm = ({ setActiveStep, setLastStep }) => {
  const { simulator, setSimulator } = useContext(AgileSimulatorContext);
  const session = useContext(SessionContext);
  const { register, handleSubmit, setValue, watch, control, clearErrors, errors } = useForm({});
  const fields = watch();
  const [isLoading, setIsLoading] = useState(false);
  const [grupos, setGrupos] = useState([
    /*{ id: 1, nombre: "1" },
    { id: 2, nombre: "2" },
    { id: 3, nombre: "3" },
    { id: 4, nombre: "4" },
    { id: 5, nombre: "5" },
    { id: 6, nombre: "6" },
    { id: 7, nombre: "7" },
    { id: 8, nombre: "8" },
    { id: 9, nombre: "9" }*/
  ]);
  const [grupoSeleccionado, setGrupoSeleccionado] = useState(false);
  const [otrosCostos, setOtrosCostos] = useState('');
  const [tasaMinima, setTasaMinima] = useState('');
  const [showGrupos, setShowGrupos] = useState(false);
  const [capacidadDisponible, setCapacidadDisponible] = useState(false);
  const [periodosDeGracia, setPeriodosDeGracia] = useState([
    { id: 1, nombre: "30" },
    { id: 2, nombre: "60" },
    { id: 3, nombre: "90" },
    { id: 4, nombre: "120" }
  ]);
  const [periodoDeGraciaSeleccionado, setPeriodoDeGraciaSeleccionado] = useState(false);
  const [showPeriodosDeGracia, setShowPeriodosDeGracia] = useState(false);
  const [tasas, setTasas] = useState([]);
  const [tasaSeleccionado, setTasaSeleccionado] = useState(false);
  const [showTasas, setShowTasas] = useState(false);
  const [valorSolicitado, setValorSolicitado] = useState(false);
  const [polizasAp, setPolizasAp] = useState([
    { id: 1, nombre: "SIN PÓLIZA AP", value: 0 },
    { id: 2, nombre: "PLAN 1", value: 150000 },
    { id: 3, nombre: "PLAN 2", value: 400000 }
  ]);
  const [polizaApSeleccionada, setPolizasApSeleccionada] = useState(false);
  const [showPolizasAp, setShowPolizasAp] = useState(false);
  const [resultado, setResultado] = useState(false);
  const [showResult, setShowResult] = useState(true);
  const [showModalInfoError, setShowModalInfoError] = useState(false);
  const [titleError, setTitleError] = useState('');
  const [messageError, setMessageError] = useState('');
  const [lineasDeCreditoBD, setLineasDeCreditoBD] = useState([
    {
      "id": 1,
      "nombre": "Libre Destino",
      "descripcion": null,
      "nombreEnum": null,
      "idBackend": "1"
    },
    {
      "id": 3,
      "nombre": "Retanqueo Libre Destino",
      "descripcion": null,
      "nombreEnum": null,
      "idBackend": "3"
    },
    {
      "id": 4,
      "nombre": "Consolidación de deudas",
      "descripcion": null,
      "nombreEnum": null,
      "idBackend": "4"
    }
  ]);
  const [showLineOfCredit, setShowLineOfCredit] = useState(false);
  const [lineaDeCredito, setLineaDeCredito] = useState(false);
  const [saldoAlDia, setSaldoAlDia] = useState(false);
  const [valorFianza, setValorFianza] = useState(false);
  const [valorEstudio, setValorEstudio] = useState(false);
  const [retanqueo, setRetanqueo] = useState(false);
  const [tarifaSeguro, setTarifaSeguro] = useState([
    { id: 1, nombre: "$2.500", value: 2500 },
    { id: 2, nombre: "$4.625", value: 4625 }
  ]);
  const [tarifaSeguroSeleccionada, setTarifaSeguroSeleccionada] = useState(false);
  const [showTarifaSeguro, setShowTarifaSeguro] = useState(false);

  const [compraCartera, setCompraCartera] = useState(false);
  const [valorCompraCartera, setValorCompraCartera] = useState(false);

  async function calculateData(dataa) {
    try {
      setIsLoading(true);
      let dataValorSolicitado = 0;
      let dataCapacidadDisponible = 0;
      let dataSaldoAlDia = 0;
      let dataValorFianza = 0;
      let dataValorEstudio = 0;
      let dataValorCompraCartera = 0;

      if (valorSolicitado) {
        dataValorSolicitado = valorSolicitado.replaceAll('$', '').replaceAll('.', '').trim()
      }

      if (capacidadDisponible) {
        dataCapacidadDisponible = capacidadDisponible.replaceAll('$', '').replaceAll('.', '').trim()
      }

      if (saldoAlDia) {
        dataSaldoAlDia = saldoAlDia.replaceAll('$', '').replaceAll('.', '').trim()
      }
      if (valorFianza) {
        dataValorFianza = valorFianza.replaceAll('$', '').replaceAll('.', '').trim()
      }

      if (valorEstudio) {
        dataValorEstudio = valorEstudio.replaceAll('$', '').replaceAll('.', '').trim()
      }
      if (valorCompraCartera) {
        dataValorCompraCartera = valorCompraCartera.replaceAll('$', '').replaceAll('.', '').trim()
      }

      const data = {
        capacidadDisponible: dataCapacidadDisponible || 0,
        tarifaSeguro: 4625,
        tasa: tasaSeleccionado.id,
        plazo: fields.plazo,
        periodoGracia: periodoDeGraciaSeleccionado.nombre,
        suretyBoun: tasaSeleccionado.suretyBond,
        creditStudy: tasaSeleccionado.creditStudy,
        valorSolicitado: retanqueo ? null : (dataValorSolicitado || 0),
        polizaAp: polizaApSeleccionada.value,
        costos: tasaSeleccionado.otherCost,
        lineaDeCredito: lineaDeCredito.idBackend,
        retanqueo: retanqueo,
        saldoAlDiaCreditoRecoger: dataSaldoAlDia || 0,
        valorFianzaPadre: dataValorFianza || 0,
        valorEstudioCreditoNeto: dataValorEstudio || 0,
        groupNumber: grupoSeleccionado.id,
        tarifaSeguro: tarifaSeguroSeleccionada.value,
        comprasSaneamientos: compraCartera ? (dataValorCompraCartera || 0) : null,
      }
      const response = await postAgileSimulatorResult(data);
      if (dataValorSolicitado > response.data?.valorMaximoDesembolsar) {
        setTitleError('Debe ingresar un valor menor al Valor Máximo a Desembolsar de los Datos Básicos')
        setShowModalInfoError(true);
      }
      setResultado(response.data);
      setShowResult(true);
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
    }

  }

  async function initializeStateComponent() {
    try {
      const responseTasas = await getAgileSimulatorTasas();
      /*const lineasCredito = await getAgileLineasDeCredito();
      const lineasCreditoValidasSA = lineaDeCredito.data.filter(linea => linea.idBackend == "1" || linea.idBackend == "3");
      setLineasDeCreditoBD(lineasCreditoValidasSA)*/
      let tasasNombre = responseTasas.data;
      let grupoNombre = responseTasas.data;
      tasasNombre = tasasNombre.map(tasa => ({
        groupNumber: tasa.groupNumber,
        id: tasa.rate,
        nombre: tasa.rate + "%",
        suretyBond: tasa.suretyBond,
        creditStudy: tasa.creditStudy,
        otherCost: tasa.otherCost
      }));

      grupoNombre = grupoNombre.map(grupo => ({
        groupNumber: grupo.groupNumber,
        id: grupo.groupNumber,
        nombre: grupo.groupNumber,
        suretyBond: grupo.suretyBond,
        creditStudy: grupo.creditStudy,
        otherCost: grupo.otherCost,
        tasaMinima: grupo.rate
      }));
      setTasas(tasasNombre);
      setGrupos(grupoNombre)
      setPolizasApSeleccionada({ id: 1, nombre: "SIN PÓLIZA AP", value: 0 });
    } catch (error) {
      console.log(error)
    }
  }

  function onBlurForm() {
    if (resultado) {
      calculateData();
    }
  }

  function onChangeFields(set, event) {
    const validChars = '0123456789$';
    const filteredValue = event.target.value.split('').filter(char => validChars.includes(char)).join('');
    set(filteredValue)
  }

  function seleccionarLineaDeCredito(lineaCredito) {
    setLineaDeCredito(lineaCredito)

    if (lineaCredito.idBackend == 3) {
      setRetanqueo(true);
      setCompraCartera(false);
    } else if (lineaCredito.idBackend == 4) {
      setCompraCartera(true);
      setRetanqueo(false);
    } else if (lineaCredito.idBackend == 1) {
      setRetanqueo(false);
      setCompraCartera(false);
    }
  }

  useEffect(() => {
    initializeStateComponent();
  }, [])

  useEffect(() => {
    if (grupoSeleccionado?.nombre && tasaSeleccionado?.nombre) {
      setCreditBound();
    }
  }, [tasaSeleccionado.id, grupoSeleccionado?.nombre])

  useEffect(() => {
    onBlurForm();
  }, [periodoDeGraciaSeleccionado.nombre, polizaApSeleccionada.value, lineaDeCredito.nombre, tarifaSeguroSeleccionada.value])

  function setSelectedGrupo(grupo) {
    setGrupoSeleccionado(grupo)
    setTasaMinima(grupo.tasaMinima + "%")
    setOtrosCostos(grupo.otherCost)
    setValue('tasaMinima', grupo.tasaMinima + "%")
    setValue('otrosCostos', grupo.otherCost)
  }

  async function setCreditBound() {
    const response = await getAgileSimulatorCreditBound(grupoSeleccionado.nombre, tasaSeleccionado.id)
    if (!response.data || Object.keys(response.data).length === 0) {
      setTitleError('La tasa seleccionada se encuentra fuera del rango del grupo seleccionado')
      setShowModalInfoError(true);
    } else {
      tasaSeleccionado.creditStudy = response.data?.credit_study;
      tasaSeleccionado.suretyBond = response.data?.surety_bond;
    }
    onBlurForm();
  }

  /*useEffect(() => {
    if (grupoSeleccionado?.nombre && tasaSeleccionado?.nombre) {
      setCreditBound();
    }
  }, [grupoSeleccionado?.nombre, tasaSeleccionado?.nombre])*/

  return (
    <div style={{ padding: '40px', paddingTop: '0px' }}>
      <Form onSubmit={handleSubmit(calculateData)}>
        <FormRow col="2">
          <div>
            <FormRow col="2">
              <Select
                error={errors.lineaCredito}
                setShow={setShowLineOfCredit}
                show={showLineOfCredit}
                defaultValue={lineaDeCredito?.nombre}
                setSelected={seleccionarLineaDeCredito}
                list={lineasDeCreditoBD}
                placeholder={"Seleccionar..."}
                label="Modalidad de crédito"
                name="lineaCredito"
                id="lineaCredito"
                register={register({ required: "Este dato es obligatorio" })}
              />
              <Select
                error={errors.grupo}
                setShow={setShowGrupos}
                show={showGrupos}
                defaultValue={grupoSeleccionado?.nombre}
                setSelected={setSelectedGrupo}
                list={grupos}
                placeholder="Seleccionar..."
                label="Grupo"
                name="grupo"
                id="grupo"
                register={register({ required: "Este dato es obligatorio" })}
              />
            </FormRow>
            <FormRow col="2">
              <InputDefault
                type="text"
                label="TASA MÍNIMA"
                name="tasaMinima"
                placeholder="Seleccione Grupo..."
                id="tasaMinima"
                error={errors.tasaMinima}
                readOnly
                value={tasaMinima}
              />
              {false &&
                <InputDefault
                  readOnly
                  type="text"
                  label={<>OTROS COSTOS<InfoCircleImage src={infoCircle} alt="info" data-tip data-for='tooltip-otros-costos' /></>}
                  name="otrosCostos"
                  placeholder="Seleccione Grupo..."
                  id="otrosCostos"
                  error={errors.otrosCostos}
                  value={otrosCostos}
                />}

              <Tooltip
                id='tooltip-otros-costos'
                effect="solid"
                place='top'
                border
                multiline
                textColor='#05443D'
                borderColor='#25BBAB'>
                <TooltipTitle>
                </TooltipTitle>
                <TooltipContent>
                  Corresponde a la sumatoria de Fianza y Estudio de Crédito.
                </TooltipContent>
              </Tooltip>
            </FormRow>
            {/** <Controller
            as={InputIntl}
            control={control}
            label="Capacidad disponible"
            name="capacidadDisponible"
            register={register({
              required: "Este dato es obligatorio",
              min: {
                value: 1,
                message: "Este dato es obligatorio"
              }
            })}
            id="capacidadDisponible"
            />*/}
            <FormRow col="2">
              <Controller
                name="capacidadDisponible"
                control={control}
                value={capacidadDisponible}
                render={({ field }) => (
                  <InputIntl
                    {...field}
                    label="Capacidad disponible"
                    error={errors.capacidadDisponible}
                    value={capacidadDisponible}
                    currencyConfig={currencyMoney}
                    setValue={setValue}
                    onBlur={() => { onBlurForm() }}
                    onChange={(event) => { onChangeFields(setCapacidadDisponible, event) }}
                  />
                )}
              />
              <InputDefault
                aria-required
                type="number"
                label="Plazo en meses"
                name="plazo"
                register={register({
                  required: "Este dato es obligatorio",
                  validate: {
                    minValue: (value) => parseFloat(value) >= 12 || 'El dato debe estar entre 12 y 144',
                    maxValue: (value) => parseFloat(value) <= 144 || 'El dato debe estar entre 12 y 144',
                  },
                })}
                placeholder="Meses"
                id="plazo"
                error={errors.plazo}
                onBlur={onBlurForm}
              />

            </FormRow>
            <FormRow col='2'>
              <Select
                error={errors.periodoDeGracia}
                setShow={setShowPeriodosDeGracia}
                show={showPeriodosDeGracia}
                defaultValue={periodoDeGraciaSeleccionado?.nombre}
                setSelected={setPeriodoDeGraciaSeleccionado}
                list={periodosDeGracia}
                placeholder="Seleccionar..."
                label="Periodo de incorporación"
                name="periodoDeGracia"
                id="periodoDeGracia"
                register={register({ required: "Este dato es obligatorio" })}
              />


              <Select
                error={errors.tasa}
                setShow={setShowTasas}
                show={showTasas}
                defaultValue={tasaSeleccionado?.nombre}
                setSelected={setTasaSeleccionado}
                list={tasas}
                placeholder="Seleccionar..."
                label="Tasa"
                name="tasa"
                id="tasa"
                register={register({ required: "Este dato es obligatorio" })}
              />


            </FormRow>
          </div>
          <div>
            {compraCartera &&
              <FormRow col="1">
                <Controller
                  name="compraCartera"
                  control={control}
                  render={({ field }) => (
                    <InputIntl
                      {...field}
                      label={
                        <>
                          Valor cartera(s) a recoger
                        </>
                      }
                      error={errors.compraCartera}
                      value={valorCompraCartera}
                      currencyConfig={currencyMoney}
                      setValue={setValue}
                      onBlur={() => { onBlurForm() }}
                      onChange={(event) => { onChangeFields(setValorCompraCartera, event) }}
                    />
                  )}
                />
              </FormRow>
            }
            {false && (!retanqueo) &&
              <FormRow col="1">
                <Controller
                  name="valorSolicitado"
                  control={control}
                  render={({ field }) => (
                    <InputIntl
                      {...field}
                      label={
                        <>
                          VALOR SOLICITADO POR CLIENTE
                          <InfoCircleImage src={infoCircle} alt="info" data-tip data-for='tooltip-valor-solicitado' />
                        </>
                      }
                      error={errors.capacidadDisponible}
                      value={valorSolicitado}
                      currencyConfig={currencyMoney}
                      setValue={setValue}
                      onBlur={() => { onBlurForm() }}
                      onChange={(event) => { onChangeFields(setValorSolicitado, event) }}
                    />
                  )}
                />
              </FormRow>
            }
            {retanqueo &&
              <FormRow col="1">
                <Controller
                  name="saldoAlDia"
                  control={control}
                  value={saldoAlDia}
                  render={({ field }) => (
                    <InputIntl
                      {...field}
                      label="Saldo al día crédito a recoger"
                      error={errors.saldoAlDia}
                      value={saldoAlDia}
                      currencyConfig={currencyMoney}
                      setValue={setValue}
                      onBlur={() => { onBlurForm() }}
                      onChange={(event) => { onChangeFields(setSaldoAlDia, event) }}
                    />
                  )}
                />
              </FormRow>}
            {false &&
              <>

                <FormRow col="1">
                  <Controller
                    name="valorFianza"
                    control={control}
                    value={valorFianza}
                    render={({ field }) => (
                      <InputIntl
                        {...field}
                        label="VALOR FIANZA PADRE"
                        error={errors.valorFianza}
                        value={valorFianza}
                        currencyConfig={currencyMoney}
                        setValue={setValue}
                        onBlur={() => { onBlurForm() }}
                        onChange={(event) => { onChangeFields(setValorFianza, event) }}
                      />
                    )}
                  />
                </FormRow>
                <FormRow col="1">
                  <Controller
                    name="valorEstudio"
                    control={control}
                    value={valorEstudio}
                    render={({ field }) => (
                      <InputIntl
                        {...field}
                        label="VALOR ESTUDIO DE CRÉDITO NETO"
                        error={errors.valorEstudio}
                        value={valorEstudio}
                        currencyConfig={currencyMoney}
                        setValue={setValue}
                        onBlur={() => { onBlurForm() }}
                        onChange={(event) => { onChangeFields(setValorEstudio, event) }}
                      />
                    )}
                  />
                </FormRow>
              </>
            }


            <Tooltip
              id='tooltip-valor-solicitado'
              effect="solid"
              place='top'
              border
              multiline
              textColor='#05443D'
              borderColor='#25BBAB'>
              <TooltipTitle>
              </TooltipTitle>
              <TooltipContent>
                Diligenciar si Valor Solicitado por el Cliente es menor al valor máximo a desembolsar que refleja en Datos Básicos.
              </TooltipContent>
            </Tooltip>
            {retanqueo &&
              <FormRow col="1">
                <Select
                  error={errors.tarifaSeguro}
                  setShow={setShowTarifaSeguro}
                  show={showTarifaSeguro}
                  defaultValue={tarifaSeguroSeleccionada?.nombre}
                  setSelected={setTarifaSeguroSeleccionada}
                  list={tarifaSeguro}
                  placeholder="Seleccionar..."
                  label="TARIFA SEGURO"
                  name="tarifaSeguro"
                  id="tarifaSeguro"
                  register={register({ required: "Este dato es obligatorio" })}
                />
              </FormRow>}
            <FormRow col="1">
              <Select
                error={errors.polizasAp}
                setShow={setShowPolizasAp}
                show={showPolizasAp}
                defaultValue={polizaApSeleccionada?.nombre}
                setSelected={setPolizasApSeleccionada}
                list={polizasAp}
                placeholder="Seleccionar..."
                label="PÓLIZA AP"
                name="polizasAp"
                id="polizasAp"
                register={register({ required: "Este dato es obligatorio" })}
              />
            </FormRow>

          </div>

        </FormRow>
        <FormFooterRigth>
          <SecondaryLargeButton col="flex-end" type="submit" id="submit">Calcular</SecondaryLargeButton>
        </FormFooterRigth>
        {showResult &&
          <FormRow col="2">
            {!retanqueo &&
              <StepFourColumn>
                <StepFourDisplayResultLabel>DATOS BÁSICOS</StepFourDisplayResultLabel>
                <StepFourDisplayValues>
                  <StepFourDisplayValuesRow>
                    <StepFourDisplayValuesRowValue>VALOR MÁXIMO CRÉDITO</StepFourDisplayValuesRowValue>
                    <StepFourDisplayValuesRowValue>$ {formatPrice(parseInt(resultado?.valorMaximoCredito) || 0)}</StepFourDisplayValuesRowValue>
                  </StepFourDisplayValuesRow>
                  <StepFourDisplayValuesRow>
                    <StepFourDisplayValuesRowValue>VALOR INTERESES PERÍODO DE INCORPORACIÓN</StepFourDisplayValuesRowValue>
                    <StepFourDisplayValuesRowValue>$ {formatPrice(parseInt(resultado?.valorInteresesPG) || 0)}</StepFourDisplayValuesRowValue>
                  </StepFourDisplayValuesRow>
                  <StepFourDisplayValuesRow>
                    <StepFourDisplayValuesRowValue>VALOR SEGUROS PERÍODO DE INCORPORACIÓN</StepFourDisplayValuesRowValue>
                    <StepFourDisplayValuesRowValue>$ {formatPrice(parseInt(resultado?.valorSegurosPG) || 0)}</StepFourDisplayValuesRowValue>
                  </StepFourDisplayValuesRow>
                  <StepFourDisplayValuesRow>
                    <StepFourDisplayValuesRowValue>VALOR FIANZA + IVA</StepFourDisplayValuesRowValue>
                    <StepFourDisplayValuesRowValue>$ {formatPrice(parseInt(resultado?.valorFianzaIVA) || 0)}</StepFourDisplayValuesRowValue>
                  </StepFourDisplayValuesRow>
                  {polizaApSeleccionada.id !== 1 &&
                    <StepFourDisplayValuesRow style={retanqueo ? { backgroundColor: '#BEFFE9' } : { display: 'flex' }}>
                      <StepFourDisplayValuesRowValue>PÓLIZA AP</StepFourDisplayValuesRowValue>
                      <StepFourDisplayValuesRowValue>$ {formatPrice(parseInt(polizaApSeleccionada.value) || 0)}</StepFourDisplayValuesRowValue>
                    </StepFourDisplayValuesRow>
                  }

                  {compraCartera &&
                    <>
                      <StepFourDisplayValuesRow>
                        <StepFourDisplayValuesRowValue>VALOR CONSOLIDACIÓN DE DEUDAS Y SANEAMIENTO</StepFourDisplayValuesRowValue>
                        <StepFourDisplayValuesRowValue>$ {formatPrice(parseInt(resultado?.comprasSaneamientos) || 0)}</StepFourDisplayValuesRowValue>
                      </StepFourDisplayValuesRow>
                      <StepFourDisplayValuesRow>
                        <StepFourDisplayValuesRowValue>GMF (4 X 1000)</StepFourDisplayValuesRowValue>
                        <StepFourDisplayValuesRowValue>$ {formatPrice(parseInt(resultado?.gmf) || 0)}</StepFourDisplayValuesRowValue>
                      </StepFourDisplayValuesRow>
                    </>
                  }
                  {(polizaApSeleccionada.id !== 1) && (!compraCartera) &&
                    <StepFourDisplayValuesRow>
                      <StepFourDisplayValuesRowValue>GMF (4 X 1000)</StepFourDisplayValuesRowValue>
                      <StepFourDisplayValuesRowValue>$ {formatPrice(parseInt(resultado?.gmf) || 0)}</StepFourDisplayValuesRowValue>
                    </StepFourDisplayValuesRow>
                  }
                  <StepFourDisplayValuesRow>
                    <StepFourDisplayValuesRowValue><b>VALOR MÁXIMO A DESEMBOLSAR</b></StepFourDisplayValuesRowValue>
                    <StepFourDisplayValuesRowValue>$ {formatPrice(parseInt(resultado?.valorMaximoDesembolsar) || 0)}</StepFourDisplayValuesRowValue>
                  </StepFourDisplayValuesRow>
                  <StepFourDisplayValuesRow>
                    <StepFourDisplayValuesRowValue><b>VALOR CUOTA MENSUAL</b></StepFourDisplayValuesRowValue>
                    <StepFourDisplayValuesRowValue>$ {formatPrice(parseInt(resultado?.valorCuotaMensual) || 0)}</StepFourDisplayValuesRowValue>
                  </StepFourDisplayValuesRow>
                </StepFourDisplayValues>
              </StepFourColumn>
            }

            {retanqueo && <StepFourColumn>
              <StepFourDisplayResultLabel>{retanqueo ? "RETANQUEOS" : "VALOR SOLICITADO POR CLIENTE"}</StepFourDisplayResultLabel>
              <StepFourDisplayValues>
                {retanqueo &&
                  <StepFourDisplayValuesRow style={{ backgroundColor: '#BEFFE9' }}>
                    <StepFourDisplayValuesRowValue>SALDO AL DÍA CRÉDITO A RECOGER</StepFourDisplayValuesRowValue>
                    <StepFourDisplayValuesRowValue>$ {formatPrice(parseInt(resultado?.saldoAlDiaCreditoRecoger) || 0)}</StepFourDisplayValuesRowValue>
                  </StepFourDisplayValuesRow>
                }
                <StepFourDisplayValuesRow>
                  <StepFourDisplayValuesRowValue>VALOR TOTAL CRÉDITO</StepFourDisplayValuesRowValue>
                  <StepFourDisplayValuesRowValue>$ {formatPrice(parseInt(resultado?.valorTotalCredito) || 0)}</StepFourDisplayValuesRowValue>
                </StepFourDisplayValuesRow>
                <StepFourDisplayValuesRow>
                  <StepFourDisplayValuesRowValue>VALOR INTERESES PERÍODO DE INCORPORACIÓN</StepFourDisplayValuesRowValue>
                  <StepFourDisplayValuesRowValue>$ {formatPrice(parseInt(resultado?.valorInteresesPGFinal) || 0)}</StepFourDisplayValuesRowValue>
                </StepFourDisplayValuesRow>
                <StepFourDisplayValuesRow>
                  <StepFourDisplayValuesRowValue>VALOR SEGUROS PERÍODO DE INCORPORACIÓN</StepFourDisplayValuesRowValue>
                  <StepFourDisplayValuesRowValue>$ {formatPrice(parseInt(resultado?.valorSegurosPGFinal) || 0)}</StepFourDisplayValuesRowValue>
                </StepFourDisplayValuesRow>
                <StepFourDisplayValuesRow>
                  <StepFourDisplayValuesRowValue>VALOR FIANZA + IVA</StepFourDisplayValuesRowValue>
                  <StepFourDisplayValuesRowValue>$ {formatPrice(parseInt(resultado?.valorFianzaIVAFinal) || 0)}</StepFourDisplayValuesRowValue>
                </StepFourDisplayValuesRow>
                {retanqueo &&
                  <>
                    {/*
                <StepFourDisplayValuesRow style={{backgroundColor: '#BEFFE9'}}>
                <StepFourDisplayValuesRowValue>VALOR FIANZA PADRE</StepFourDisplayValuesRowValue>
                <StepFourDisplayValuesRowValue>$ {formatPrice(parseInt(resultado?.valorFianzaPadre) || 0)}</StepFourDisplayValuesRowValue>
              </StepFourDisplayValuesRow>
              <StepFourDisplayValuesRow>
              <StepFourDisplayValuesRowValue>VALOR FIANZA NETA</StepFourDisplayValuesRowValue>
              <StepFourDisplayValuesRowValue>$ {formatPrice(parseInt(resultado?.valorFianzaNeta) || 0)}</StepFourDisplayValuesRowValue>
            </StepFourDisplayValuesRow>
                 */}
                    {/*
                    <StepFourDisplayValuesRow style={{ backgroundColor: '#BEFFE9' }}>
                      <StepFourDisplayValuesRowValue >VALOR ESTUDIO DE CRÉDITO NETO</StepFourDisplayValuesRowValue>
                      <StepFourDisplayValuesRowValue>$ {formatPrice(parseInt(resultado?.valorEstudioCreditoNeto) || 0)}</StepFourDisplayValuesRowValue>
                    </StepFourDisplayValuesRow>
                    */}
                  </>

                }
                {false &&
                  <StepFourDisplayValuesRow>
                    <StepFourDisplayValuesRowValue>VALOR ESTUDIO DE CRÉDITO + IVA</StepFourDisplayValuesRowValue>
                    <StepFourDisplayValuesRowValue>$ {formatPrice(parseInt(resultado?.valorEstudioCreditoIVAFinal) || 0)}</StepFourDisplayValuesRowValue>
                  </StepFourDisplayValuesRow>
                }
                {polizaApSeleccionada.id !== 1 &&
                  <>
                    <StepFourDisplayValuesRow style={retanqueo ? { backgroundColor: '#BEFFE9' } : { display: 'flex' }}>
                      <StepFourDisplayValuesRowValue>PÓLIZA AP</StepFourDisplayValuesRowValue>
                      <StepFourDisplayValuesRowValue>$ {formatPrice(parseInt(polizaApSeleccionada.value) || 0)}</StepFourDisplayValuesRowValue>
                    </StepFourDisplayValuesRow>


                    <StepFourDisplayValuesRow>
                      <StepFourDisplayValuesRowValue>GMF (4 X 1000)</StepFourDisplayValuesRowValue>
                      <StepFourDisplayValuesRowValue>$ {formatPrice(parseInt(resultado?.gmf) || 0)}</StepFourDisplayValuesRowValue>
                    </StepFourDisplayValuesRow>
                  </>
                }

                {false &&
                  <StepFourDisplayValuesRow>
                    <StepFourDisplayValuesRowValue><b>REMANENTE</b></StepFourDisplayValuesRowValue>
                    <StepFourDisplayValuesRowValue>$ {formatPrice(parseInt(resultado?.remanenteEstimado) || 0)}</StepFourDisplayValuesRowValue>
                  </StepFourDisplayValuesRow>
                }

                <StepFourDisplayValuesRow>
                  <StepFourDisplayValuesRowValue><b>{retanqueo ? "VALOR MÁXIMO A DESEMBOLSAR" : "VALOR A DESEMBOLSAR"}</b></StepFourDisplayValuesRowValue>
                  <StepFourDisplayValuesRowValue>$ {formatPrice(parseInt(resultado?.remanenteEstimado) || 0)}</StepFourDisplayValuesRowValue>
                </StepFourDisplayValuesRow>
                <StepFourDisplayValuesRow>
                  <StepFourDisplayValuesRowValue><b>VALOR CUOTA MENSUAL</b></StepFourDisplayValuesRowValue>
                  <StepFourDisplayValuesRowValue>$ {formatPrice(parseInt(resultado?.valorCuotaMensualFinal) || 0)}</StepFourDisplayValuesRowValue>
                </StepFourDisplayValuesRow>
              </StepFourDisplayValues>
            </StepFourColumn>}

          </FormRow>}
        {isLoading && <Loader></Loader>}
        <ModalInfo
          open={showModalInfoError}
          setShowModal={setShowModalInfoError}
          title={titleError}
          description={messageError}
          backgroundIcon={colors.bgDanger}
          bodyIcon={<BsExclamation size={32} color={colors.white} id="exclamation-icon" />} />
      </Form>

    </div >
  )
}

export default AgileSimulatorForm
